{
  "menu": {
    "about": "About Us",
    "facilities": "Facilities",
    "villas": "Villas & Rates",
    "allRooms": "All Rooms",
    "experiences": "Things to Do",
    "gallery": "Gallery",
    "news": "News",
    "dining": "Dining",
    "spa": "Spa"
  },
  "cta": {
    "book": "Book Now",
    "contact": "Contact Us",
    "back_to_home": "Back to Home",
    "read_more": "Read More"
  },
  "home": {
    "culture": {
      "subtitle": "Authentic Balinese Heritage",
      "title": "Culture Experiences",
      "desc": "Immerse yourself in the rich spiritual and cultural heritage of Bali. From sacred water purification rituals to exploring ancient traditions, we guide you on a journey to discover the true soul of the island.",
      "journeySub": "Spiritual Journey",
      "journeyTitle": "Sidemen Purification",
      "journeyDesc": "Experience a traditional Balinese water purification ritual (Melukat) in the sacred springs of Sidemen, designed to cleanse your body, mind, and spirit.",
      "btnReserve": "Reservation"
    },
    "activities": {
      "subtitle": "Curated Moments",
      "title": "Things To Do",
      "desc": "We provide the finest curated activities to create unforgettable memories during your stay. Immerse yourself in the magic of Bali, from thrilling adventures to deep cultural explorations and spiritual wellness.",
      "btnView": "View Activities",
      "btnReserve": "Reservation"
    },
    "different": {
      "subtitle": "Patal Kikian Sidemen",
      "title": "What Makes Us Different",
      "desc": "Discover the true essence of a hidden gem. Far from the crowds, we offer a secluded sanctuary where every detail is designed to help you disconnect, recharge, and leave with beautiful memories that last a lifetime.",
      "card1": {
        "sub": "A private sanctuary away from the world",
        "title": "Sidemen's Hidden Gem",
        "desc": "Tucked away from the busy streets, our villa offers the ultimate exclusivity and privacy. Here, you are not just a guest, but a privileged traveler experiencing the untouched serenity of authentic Bali."
      },
      "card2": {
        "sub": "Awaken your senses and recharge your soul",
        "title": "Renewed Energy",
        "desc": "Breathe in the fresh air from our lush tropical gardens and expansive ricefields. Every moment spent in our peaceful surroundings is designed to rejuvenate your mind, body, and spirit."
      },
      "card3": {
        "sub": "Moments you will treasure forever",
        "title": "Beautiful Memories",
        "desc": "From heartfelt smiles to authentic local experiences, we craft every detail of your stay with genuine care. Return home not just rested, but with beautiful, unforgettable stories to tell."
      }
    },
    "booking": {
      "title": "Ready to Experience Patal Kikian?",
      "desc": "Check availability and secure your private sanctuary today."
    },
    "contact": {
      "subtitle": "Contact",
      "title": "How to reach us",
      "desc": "Whether you have a question about our rooms, need assistance with your booking, or have a special request for your upcoming stay, our dedicated concierge team is here to help.",
      "btnEmail": "Send an Email",
      "btnWa": "WhatsApp Us"
    },
    "hero": {
      "subtitle": "Welcome to Patal Kikian Villas",
      "title": "Awaken to Bali's Most Breathtaking Panorama",
      "description": "Embrace the majestic presence of Mount Agung as it watches over emerald rice terraces and lush, rolling valleys. Here in the peaceful embrace of Sidemen, the crisp mountain air and untouched serenity weave together to create an unforgettable sanctuary for your soul."
    },
    "intro": {
      "quote": "\"For decades, the captivating beauty of Sidemen has inspired the world.\"",
      "p1": "In 1938, legendary artist Walter Spies immortalized the enchanting charm of this region through his masterpiece, <span className=\"italic text-white\">“Morning in Iseh.”</span> The painting beautifully captured the towering majesty of Mount Agung, the lush emerald rice terraces, the soft morning mist, and the peaceful rhythm of rural Balinese life. To this day, it remains an iconic symbol of Bali’s natural splendor.",
      "p2": "Today, this very same breathtaking panorama unfolds right before your eyes at Patal Kikian Villas.",
      "p3": "Every morning brings a spectacular sunrise that bathes Mount Agung in golden light, illuminating sweeping green valleys and bringing a crisp, fresh mountain breeze. Here, tranquility reigns, making time feel as though it has slowed down.",
      "p4": "At Patal Kikian, you are not merely staying in a luxury villa; you are immersing yourself in the very landscape that has captivated artists, photographers, and nature lovers from every corner of the globe.",
      "p5": "We offer a flawless harmony of refined luxury, deep cultural heritage, and the authentic natural beauty of Sidemen.",
      "footerQuote": "Arrive for a holiday. Leave with memories you will forever yearn for.",
      "footerBrand": "Patal Kikian Villas",
      "footerTagline": "Where Every Sunrise Becomes a Masterpiece"
    },
    "restaurant": {
      "subtitle": "Patal Kikian Sidemen",
      "title": "Patal Kikian Restaurant",
      "desc": "Set beside our infinity pool and elegant bar, our restaurant offers a remarkable dining experience framed by sweeping views of the lush green valleys and vast ricefields. Savor exquisite culinary creations as the gentle breeze and breathtaking natural surroundings awaken your senses.",
      "callToAction": "Explore our exquisite culinary offerings. Discover our local and international specialties by viewing our menu, or reserve your table for an unforgettable dining experience.",
      "btnMenu": "View Menu",
      "btnReserve": "Reservation",
      "btnTransport": "Special Transport Reservation",
      "btnTransportSub": "(Sidemen Area)",
      "btnMaps": "Google Maps",
      "btnMapsSub": "Location"
    },
    "spa": {
      "subtitle": "Patal Kikian Sidemen",
      "title": "Patal Kikian Spa",
      "desc": "Rejuvenate your mind, body, and soul at Patal Kikian Spa. Experience authentic Balinese healing rituals and relaxing massages performed by our skilled therapists, all while taking in the breathtaking natural beauty of Sidemen.",
      "callToAction": "Discover our full range of holistic treatments. View our spa menu to explore our relaxing therapies, or book your rejuvenating session today.",
      "btnMenu": "View Menu",
      "btnReserve": "Reservation",
      "btnTransport": "Special Transport Reservation",
      "btnTransportSub": "(Sidemen Area)",
      "btnMaps": "Google Maps",
      "btnMapsSub": "Location"
    },
    "rooms": {
      "subtitle": "Patal Kikian Sidemen",
      "title": "Patal Kikian Villa",
      "desc": "Every villa is thoughtfully designed as your private sanctuary, featuring breathtaking, uninterrupted views of Mount Agung, vast rice paddies and lush green valleys, seamlessly blending luxury with the serenity of nature."
    }
  },
  "about": {
    "hero": {
      "subtitle": "Our Story",
      "title": "Awaken to Bali's Most Breathtaking Panorama",
      "desc": "Embrace the majestic presence of Mount Agung as it watches over emerald rice terraces and lush, rolling valleys. Here in the peaceful embrace of Sidemen, the crisp mountain air and untouched serenity weave together to create an unforgettable sanctuary for your soul.",
      "btnScroll": "Read Story"
    },
    "story": {
      "p1": "Nestled on the edge of Sidemen, Karangasem, Patal Kikian Villas is more than just a destination; it is an invitation to experience the very heartbeat of Bali. With panoramic views from the top of the hill, every morning here begins with a symphony of nature—a golden sunrise illuminating the towering peak of Mount Agung, framed by endless greenery and pristine landscapes.",
      "p2": "We believe that true luxury lies in harmony with nature. As you step into our sanctuary, you are enveloped by fresh, crisp mountain air and a profound sense of tranquility. It is a place designed to disconnect you from the noise of the world and reconnect you with what truly matters.",
      "subtitle": "A Harmony of Nature and Culture",
      "p3": "Our villas reflect a seamless blend of traditional Balinese architecture and modern comfort, carefully crafted to honor the rich culture of Sidemen. We take pride in our warm, authentic hospitality. Here, every smile is genuine, and every service is provided with the deepest respect for both our guests and our local heritage.",
      "quote": "\"Patal Kikian Villas is your hidden paradise—a place where majestic landscapes, rich culture, and heartfelt hospitality weave an unforgettable tapestry of memories.\"",
      "footer": "We look forward to welcoming you to our sanctuary."
    }
  },
  "facilities": {
    "hero": {
      "subtitle": "Resort Amenities",
      "title": "Our Facilities",
      "desc": "Discover our premium amenities designed to provide comfort and relaxation throughout your stay in Sidemen.",
      "btnScroll": "View Facilities"
    },
    "fallback": {
      "poolSub": "Oasis of Serenity",
      "poolTitle": "Swimming Pools",
      "poolDesc1": "Immerse yourself in our crystal-clear infinity pools overlooking the vibrant tropical gardens and lush valley. Whether you are enjoying a morning swim, a floating breakfast, or simply lounging under the sun with a refreshing cocktail, our pools offer the ultimate space for relaxation.",
      "poolDesc2": "Private plunge pools are also available in select villas for those seeking an intimate retreat.",
      "restSub": "Culinary Excellence",
      "restTitle": "Restaurant",
      "restDesc1": "Indulge in a gastronomic journey at our signature open-air restaurant. We pride ourselves on serving authentic Balinese cuisine alongside international favorites, all crafted from the freshest, locally sourced organic ingredients.",
      "restDesc2": "Enjoy your complimentary breakfast, romantic candlelit dinners, or casual afternoon teas while taking in the breathtaking views of the surrounding nature.",
      "restBtn": "View More",
      "spaSub": "Wellness & Healing",
      "spaTitle": "Luxury Spa",
      "spaDesc1": "Rejuvenate your mind, body, and soul at our tranquil spa sanctuary. Rooted in ancient Balinese healing traditions, our professional therapists offer a range of treatments from traditional massages to revitalizing body scrubs and facials.",
      "spaDesc2": "As our guest, you will also receive a complimentary 15-minute foot massage upon arrival to instantly wash away your travel fatigue.",
      "spaBtn": "View More"
    }
  },
  "accommodation": {
    "hero": {
      "subtitle": "Our Rooms",
      "title": "Sanctuaries of Serenity at Patal Kikian Villas",
      "desc": "Experience ultimate tranquility in our thoughtfully designed villas, blending modern comfort with Balinese authenticity.",
      "btnScroll": "Explore Rooms"
    },
    "detail": {
      "loading": "Loading Room Details...",
      "signature": "Signature Room",
      "gallerySub": "Gallery",
      "galleryTitle": "Room Photo Gallery",
      "noImages": "No images available for this room type.",
      "aboutRoom": "About the Room",
      "roomSize": "Room Size",
      "bedSize": "Bed Size",
      "view": "View",
      "amenities": "Amenities",
      "inclusions": "Inclusions",
      "pleaseNote": "Please Note",
      "roomRules": "Room Rules & Information",
      "roomPolicy": "Room Policy",
      "childrenPolicies": "Children policies",
      "childrenPolicyDesc": "Children of any age are allowed. Children up to and including 5 years old can stay for free. Children from 6 years old to 12 years old can stay for IDR 151.250,00 per child per night with extra bed.",
      "babyCot": "Baby cot",
      "babyCotDesc": "Children up to and including 2 years old stay for free when using an available cot.",
      "extraBed": "Extra Bed",
      "extraBedDesc": "People no matter the age stay for IDR 302.500,00 per person per night when using an available extra bed.",
      "noSmoking": "Smoking is not allowed.",
      "noPets": "Pets are not allowed.",
      "reserve": "Reserve",
      "directBooking": "Direct Booking From Us",
      "bookOnBooking": "Book on Booking.com",
      "contactConcierge": "Contact our concierge for booking questions and custom requests.",
      "otherChoices": "Other Choices",
      "otherRooms": "Other Rooms You Might Like",
      "bookYourStay": "Book Your Stay"
    }
  },
  "luxuryCard": {
    "discover": "Discover"
  },
  "rooms": {
    "deluxe-bungalow-mountain-view": {
      "title": "Deluxe Bungalow (Mountain View)",
      "description": "This bungalow features a infinity pool. Featuring a private entrance, this air-conditioned bungalow consists of 1 living room, 1 separate bedroom and 1 bathroom with a shower and a hairdryer. The bungalow is furnished with a desk and a seating area and provides a mini-bar, a tea and coffee maker and garden views. The unit offers 1 bed.",
      "view": "Garden, Pool, Mountain, Landmark & River View",
      "roomRules": "Smoking: No smoking. Quiet hours after 10 PM. Check-in at 2 PM, Check-out at 12 PM."
    },
    "suite-room-mountain-view": {
      "title": "Suite Room (Mountain View)",
      "description": "Guests will have a special experience as this suite offers a pool with a view. Featuring a private entrance, this spacious suite also is consisted of of 1 bedroom, a seating area and 1 bathroom with a shower and a hairdryer. The unit features air conditioning, garden views, a terrace and wine/champagne is featured for guests. The unit offers 1 bed.",
      "view": "Mountain, River, Landmark, Pool & Garden View",
      "roomRules": "Smoking: No smoking. Quiet hours after 10 PM. Check-in at 2 PM, Check-out at 12 PM."
    },
    "private-pool-villa-mountain-view": {
      "title": "Private Pool Villa (Mountain View)",
      "description": "This villa features a pool with a view. Featuring a private entrance, this air-conditioned villa consists of 1 living room, 1 separate bedroom and 1 bathroom with a bath and a shower. The spacious villa provides a mini-bar, a tea and coffee maker, a seating area as well as a terrace with garden views. The unit offers 1 bed.",
      "view": "Garden, Pool, Mountain & River View",
      "roomRules": "Smoking: No smoking. Quiet hours after 10 PM. Check-in at 2 PM, Check-out at 12 PM."
    },
    "features": {
      "Infinity Pool": "Infinity Pool",
      "Mountain View": "Mountain View",
      "Private Balcony": "Private Balcony",
      "Private Pool": "Private Pool",
      "Mount Agung View": "Mount Agung View",
      "Living Room": "Living Room",
      "Nature View": "Nature View",
      "Bedroom": "Bedroom"
    }
  },
  "experiences": {
    "hero": {
      "subtitle": "Things To Do",
      "title": "Create Your Best Memories in Bali",
      "desc": "From breathtaking nature adventures to immersive cultural experiences, we present a curated selection of activities to make every moment of your holiday even more special.",
      "btnScroll": "View Activities"
    },
    "sidebar": {
      "categories": "Categories",
      "moreActivities": "More Activities"
    },
    "categories": {
      "Adventure & Nature": "Adventure & Nature",
      "Culture & Art": "Culture & Art",
      "Wellness & Spiritual": "Wellness & Spiritual"
    },
    "items": {
      "ATV Adventure": {
        "title": "ATV Adventure",
        "description": "Experience the thrill of riding an ATV through the beautiful landscapes of Bali."
      },
      "Cycling Tour": {
        "title": "Cycling Tour",
        "description": "Cycle through lush rice paddies and traditional villages on a guided tour."
      },
      "Rice Terrace Walking Tour": {
        "title": "Rice Terrace Walking Tour",
        "description": "Take a peaceful stroll through some of the most iconic rice terraces in the world."
      },
      "Sunrise Jeep Mount Batur": {
        "title": "Sunrise Jeep Mount Batur",
        "description": "Witness a breathtaking sunrise from Mount Batur without the early morning hike."
      },
      "Scooter Tour": {
        "title": "Scooter Tour",
        "description": "Explore the hidden gems of Sidemen on a thrilling guided scooter tour."
      },
      "Rafting": {
        "title": "Rafting",
        "description": "Experience the adrenaline rush of white water rafting down the Ayung River."
      },
      "Batur Trekking": {
        "title": "Batur Trekking",
        "description": "Hike up the active volcano of Mount Batur and watch the sunrise from the summit."
      },
      "Waterfall Tour": {
        "title": "Waterfall Tour",
        "description": "Visit some of the most stunning and hidden waterfalls in the Sidemen area."
      },
      "Swing": {
        "title": "Swing",
        "description": "Experience the adrenaline of swinging high above the stunning valleys and jungles of Bali."
      },
      "Mount Agung Trekking": {
        "title": "Mount Agung Trekking",
        "description": "Challenge yourself with a rewarding sunrise trek to the highest peak in Bali, Mount Agung."
      },
      "Cooking Class": {
        "title": "Cooking Class",
        "description": "Learn the secrets of authentic Balinese cuisine with our expert local chefs."
      },
      "Silver Class": {
        "title": "Silver Class",
        "description": "Create your own unique silver jewelry guided by traditional silversmiths."
      },
      "Coffee Plantation Tour": {
        "title": "Coffee Plantation Tour",
        "description": "Discover the process of making traditional Balinese coffee, including the famous Luwak coffee."
      },
      "Yoga & Wellness": {
        "title": "Yoga & Wellness",
        "description": "Rejuvenate your mind and body with our guided yoga and wellness sessions."
      }
    }
  },
  "restaurant": {
    "categories": {
      "Appetizers": "Appetizers",
      "Soup": "Soup",
      "Pasta": "Pasta",
      "Main Course": "Main Course",
      "Indonesian Food": "Indonesian Food",
      "Dessert": "Dessert",
      "Beverages": "Beverages"
    },
    "hero": {
      "subtitle": "Leaf Forest Restaurant",
      "title": "A Soul-Soothing Culinary Journey",
      "desc": "Indulge in exquisite culinary creations that nourish the body, accompanied by the majestic panorama of Mount Agung and the lush green valleys of Sidemen—a setting designed to calm the heart and refresh the mind.",
      "btnScroll": "View Menu"
    },
    "sidebar": {
      "categories": "Categories",
      "moreCategories": "More Categories"
    },
    "backToHome": "Back to Home"
  },
  "spa": {
    "categories": {
      "Body Massage": "Body Massage",
      "Specialty Treatments": "Specialty Treatments",
      "Body Scrub and Mask": "Body Scrub and Mask",
      "Facial Treatment": "Facial Treatment",
      "Manicure and Pedicure": "Manicure and Pedicure",
      "Spa Packages": "Spa Packages"
    },
    "hero": {
      "subtitle": "Welcome To Patal Kikian Spa",
      "title": "Where the Body Rests, the Soul Returns",
      "desc": "Our spa tends to your weary body, while the lush nature of Sidemen embraces your tired heart. Against the majestic backdrop of Mount Agung, rediscover profound tranquility in every single breath.",
      "btnScroll": "View Spa Menu"
    },
    "sidebar": {
      "treatments": "Treatments",
      "moreTreatments": "More Treatments"
    },
    "backToHome": "Back to Home"
  },
  "news": {
    "journal": "Journal",
    "latest": "Latest News & Stories",
    "subtitle": "Stay updated with the latest news, stories, and events happening around Patal Kikian and Sidemen.",
    "readNews": "Read News",
    "allArticles": "All Articles",
    "noArticles": "No articles found in this category.",
    "page": "Page",
    "of": "of"
  },
  "newsSearch": {
    "searchBreadcrumb": "Search",
    "searchResults": "Search Results",
    "searchArticles": "Search Articles",
    "resultsFound": "{{count}} results found",
    "forQuery": " for \"{{query}}\"",
    "placeholder": "Search articles...",
    "searchBtn": "Search",
    "noResults": "No articles found matching \"{{query}}\".",
    "enterKeyword": "Enter a keyword to search articles.",
    "backToNews": "Back to News"
  },
  "newsCategory": {
    "category": "Category",
    "articlesInCat": "articles in this category",
    "noArticles": "No articles found in this category.",
    "backToNews": "Back to News"
  },
  "newsDetail": {
    "tags": "Tags",
    "exclusiveStay": "Exclusive Stay",
    "promoDesc": "Experience Premium Luxury in Sidemen",
    "bookStay": "Book Your Stay",
    "reserveStay": "Reserve Your Stay",
    "villaRecs": "Villa Recommendations",
    "recAccommodations": "Recommended Accommodations",
    "readArticle": "Read Article",
    "search": "Search",
    "searchPlaceholder": "Search articles...",
    "go": "Go",
    "categories": "Categories",
    "popularPosts": "Popular Posts",
    "bookNow": "Book Now",
    "notFound": "Article Not Found",
    "notFoundDesc": "The news article you are looking for does not exist or has been moved.",
    "backToNews": "Back to News"
  }
}